const API_BASE_URL = "https://api.delphys7-prpo.online/";

export default API_BASE_URL


// // src/config.js
// const API_BASE_URL = "http://localhost:7266/";

// export default API_BASE_URL;



// // // demo
// const API_BASE_URL = "http://103.102.46.28:9393/";

// export default API_BASE_URL;
